export const SHORT_PAYMENTS_STATUS = {
	COMPLETE: 'Complete',
	INACTIVE: 'Inactive customer',
	PROCESSED: 'Processed by customer'
};
